export const CACHE_KEY_LIST_NOMENCLATURES_ACTIVITIES = 'nomenclatures-activities';
export const CACHE_KEY_NOMENCLATURES_ACTIVITIES = 'nomenclatures-activities-one';
export const ROUTE_PATH_NOMENCLATURES_ACTIVITIES = '/settings/nomenclatures/activities';
export const TRANSLATION_PREFIX_NOMENCLATURES_ACTIVITIES = 'nomenclaturesActivities';

